import { Info } from "./GridFrameworks";

export const columnDef = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: Info,
        width: 60,
    },
    {
        headerName: "Name",
        field: "Name",
        flex: 1,
    },
    {
        headerName: "Status",
        field: "IsActive",
        cellRenderer: "StatusCellRenderer",
        width: 120,
    },
];
